import React from 'react';
import injectIntl, { intlShape } from 'common/injectIntl';
import Logout from './Logout';

const ProviderSettings = ({
    displayLogout,
    handleLogin,
    handleLogout,
    providerInfo,
    messages,
    intl: { formatMessage }
}) => {
    const logoutEl = displayLogout ? (
        <Logout
            handleLogout={handleLogout}
            message={formatMessage(messages['signout.message'], { providerName: providerInfo.name })}
            buttonLabel={formatMessage(messages['signout.label'])}
        />
    ) : null;
    const logoutClass = displayLogout === true ? 'playback__settingsLink icon-font-before icon-caret-down-solid-before' :
        'playback__settingsLink icon-font-before';

    return (
        <div className="playback__settings playback__settings--active">
            <a className={logoutClass} onClick={handleLogin}>
                <span className="playback__settingsText">
                    {formatMessage(messages['provider.dialog.title'])}
                </span>
            </a>
            {logoutEl}
        </div>
    );
};

ProviderSettings.defaultProps = {
    providerInfo: {}
};

ProviderSettings.propTypes = {
    displayLogout: React.PropTypes.bool,
    handleLogout: React.PropTypes.func,
    handleLogin: React.PropTypes.func,
    providerInfo: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

export default injectIntl(ProviderSettings);



// WEBPACK FOOTER //
// ./app/branding/ProviderSettings.js